import { DateWithTimezones, MapStopActionType, MapStopType, PointData } from '../../common';

export class ShipmentLoadToGpsPointModel implements PointData {
  viewType: MapStopType;
  latitude: number;
  longitude: number;
  dateTime: DateWithTimezones;
  extId: string;
  name: string;
  address: string;
  actions: MapStopActionType[];
  sortIndex: string;
}
